import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoHe: CultureInfo = {
  name: 'he',
  displayName: 'Hebrew',
  iso3LanguageCode: 'heb',
  iso2LanguageCode: 'he',
  ietfLanguageTag: 'he',
  parent: null
};
